// extracted by mini-css-extract-plugin
export default {"main":"Home_main__dNR-k","text":"Home_text__N22hs","slide-right":"Home_slide-right__Liq8B","photo":"Home_photo__EX+4C","slide-left":"Home_slide-left__ytozP"};